const ROULES = {
  menuUrl: 'menuPath',
  code: 'menuCode',
  name: 'menuName',
};

class PermissionsTranslation {
  //  model = {
  //   children: [],
  //   frontComponent: "",
  //   icon: "",
  //   menuCode: "",
  //   menuId: "",
  //   menuName: "",
  //   menuPath: "", // 一级菜单 默认 -1
  //   parentMenuId: "", // 一级菜单 默认 -1
  //   resources: [], // 按钮级别权限
  //   sort: 0, // 排序
  //  };
  //  menuRules = {
  //   menuUrl: "menuPath",

  //  };
  constructor() {
    if (typeof PermissionsTranslation.instance === 'object') {
      return PermissionsTranslation.instance;
    }
    PermissionsTranslation.instance = this;
    this.init();
  }

  /**
   * 初始化
   * @return
   */
  // eslint-disable-next-line class-methods-use-this
  init() { }

  /**
   * 格式化菜单级数据
   * @return
   */
  formattingMenu(menus) {
    // eslint-disable-next-line no-underscore-dangle
    const _menuslist = JSON.parse(JSON.stringify(menus));
    // eslint-disable-next-line no-use-before-define
    eachMenus(_menuslist, this);
    function eachMenus(k) {
      if (k instanceof Array) {
        k.forEach((e) => {
          // eslint-disable-next-line no-restricted-syntax, guard-for-in
          for (const key in ROULES) {
            e[ROULES[key]] = e[key];
          }
          // eslint-disable-next-line dot-notation
          e['resources'] = []; // 按钮级别权限
          eachMenus(e.children);
        });
      } else {
        // eslint-disable-next-line no-useless-return
        return;
      }
    }
    return _menuslist;
  }
}

export default PermissionsTranslation;
